import { LiksTextFormField } from '../../components/liks/LiksTextFormField/LiksTextFormField';
import { useI18n } from '../../i18n/useI18n';

type CreateTenantUserDialogOptionalFieldsProps = {
  id: string;
  validFrom: string;
  validTo: string;
  isValidToBeforeValidFrom: boolean;
  isSubmitting: boolean;
  onValidFromChange: (value: string) => void;
  onValidToChange: (value: string) => void;
};

export function CreateTenantUserDialogOptionalFields({
  id,
  validFrom,
  validTo,
  isValidToBeforeValidFrom,
  isSubmitting,
  onValidFromChange,
  onValidToChange,
}: CreateTenantUserDialogOptionalFieldsProps) {
  const { translate } = useI18n();

  return (
    <div id={id} className="lac-create-user__optional-fields">
      <div className="lac-create-user__row">
        <LiksTextFormField
          label={translate(
            'organisationManagement.users.create.validFromLabel',
          )}
          type="date"
          value={validFrom}
          onChange={onValidFromChange}
          disabled={isSubmitting}
        />

        <LiksTextFormField
          label={translate('organisationManagement.users.create.validToLabel')}
          type="date"
          value={validTo}
          onChange={onValidToChange}
          disabled={isSubmitting}
          error={
            isValidToBeforeValidFrom
              ? translate(
                  'organisationManagement.users.create.validToBeforeValidFrom',
                )
              : null
          }
        />
      </div>
    </div>
  );
}
